import { useMediaQuery } from '@material-ui/core';
import React from 'react';

import Button from '../../../../components/Button';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Input from '../../../../components/Inputs/Input';
import Select from '../../../../components/Inputs/Select';
import { ContainerDataTable, PageContainer } from '../../../../styles/styles';

import DataTableMui from '../../../../components/DataTableMui';
import Icon from '../../../../components/Icons';
import PageLoader from '../../../../components/PageLoader';
import { useGlobal } from '../../../../contexts/Global/context';
import { useSolicitacaoGuias } from '../../../../contexts/SolicitacaoGuias/context';
import { getDownloadGuide, getGuides, getTypesGuides } from '../../../../services/registroAcidentados/consultarGuias';
import { cloneObject } from '../../../../utils';
import filterSchema from './schema';
import * as S from './styles';

const ConsultarGuias = () => {
    const { contrastTheme } = useGlobal();

    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = React.useState(false);
    // eslint-disable-next-line no-unused-vars
    const [alreadySearched, setAlreadySearched] = React.useState(false);
    const [pageLoading, setPageLoading] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [types, setTypes] = React.useState([]);
    const { dataBeneficiario } = useSolicitacaoGuias();

    const matchMediaQuery = useMediaQuery('(max-width: 960px)');

    const [filterValues, setFilterValues] = React.useState({
        ...cloneObject(filterSchema),
    });

    async function loadTypesGuides() {
        try {
            const typesGuides = await getTypesGuides();

            const typesGuidesFiltered = typesGuides?.map((element) => ({
                codigo: element.tipo,
                nome: element.descricao,
            }));

            return typesGuidesFiltered;
        } catch (error) {
            console.error(error)
        }

        return []

    }

    React.useEffect(() => {
        const fetchTypes = async () => {
            const typesResponse = await loadTypesGuides();

            setTypes(typesResponse);
        };

        fetchTypes();
    }, []);

    async function handleChangeInput(event) {
        const { id, value, ...rest } = event;
        const field = { ...filterValues[id], value, error: '', ...rest };
        const editedForm = { ...filterValues, [id]: field };

        setFilterValues(editedForm);
    }

    const emptyMessage = 'Não encontramos guias para este beneficiário. Você pode fazer uma nova pesquisa.';

    const handleSubmit = async () => {
        if ((typeof filterValues.guidance.value === "string"
            && filterValues.guidance.value.length) || (typeof filterValues.from.value === "string"
                && filterValues.from.value.length
                && typeof filterValues.at.value === "string"
                && filterValues.at.value.length)) {
            setPageLoading(true)
            if (
                typeof filterValues.types.value === "string"
                && filterValues.types.value.length
            ) {
                const response = await getGuides(
                    dataBeneficiario[0].numCarteirinha,
                    typeof filterValues.from.value === "string" && filterValues.from.value.length ? filterValues.from : " ",
                    typeof filterValues.at.value === "string" && filterValues.at.value.length ? filterValues.at : " ",
                    filterValues.guidance,
                    filterValues.types,
                );

                setData(response);
                setAlreadySearched(true)
                setPageLoading(false)
            } else {
                setData([])
                setAlreadySearched(false)
                setPageLoading(false)
            }

            setPageLoading(false)
        }
    }

    const handleDownload = async (guidance) => {
        const file = await getDownloadGuide(dataBeneficiario[0].numCarteirinha, guidance, filterValues.types);

        const fileURL = window.URL.createObjectURL(file);

        // eslint-disable-next-line
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'Guia.pdf';
        alink.click();
    };

    const columnsHead = [
        {
            key: 'carteirinha',
            selector: (row) => row.carteirinha || '-',
            name: 'Nº da carteirinha',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'numeroGuia',
            selector: (row) => row.numeroGuia || '-',
            name: 'Nº da guia',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeBeneficiario',
            selector: (row) => row.nomeBeneficiario || '-',
            name: 'Beneficiário',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'nomeCredenciado',
            selector: (row) => row.nomeCredenciado || '-',
            name: 'Credenciado',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: 'calc(100% - 600px)', height: '60px' }),
        },
        {
            key: 'dataAutorizacao',
            selector: (row) => row.dataAutorizacao || '-',
            name: 'Data Autorização',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'situacao',
            selector: (row) => row.situacao,
            name: 'Status',
            sortable: true,
            direction: 'center',
            customStyles: () => ({ width: '200px' }),
        },
        {
            key: 'tipoOperacao',
            selector: (row) => row,
            name: 'Opções',
            sortable: false,
            direction: 'center',
            mutation: ({ numeroGuia }) => (
                <S.CellWithIcon>
                    <Icon
                        name="file_download"
                        color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                        onClick={() => handleDownload(numeroGuia)}
                        tooltip={<S.TooltipText>Baixar guia</S.TooltipText>}
                        size={22}
                    />
                </S.CellWithIcon>
            ),
            customStyles: () => ({ width: '70px' }),
            customClassName: 'status-column',
        },
    ];

    return (
        <>
            <PageContainer>
                <S.SectionContainer style={{ padding: '32px 32px 0' }}>
                    <S.container>
                        <S.FirstColumn showFilters={!matchMediaQuery}>
                            <S.SelectContainer style={{ flexDirection: 'column', justifyContent: 'end' }}>
                                <Select
                                    onChange={handleChangeInput}
                                    field={{
                                        ...filterValues.types,
                                        options: types,
                                        required: true,
                                    }}
                                />
                            </S.SelectContainer>

                            <S.Row>
                                <Input field={filterValues.guidance} onChange={handleChangeInput} />
                            </S.Row>

                            <S.Row>
                                <DatepickerMui
                                    field={{
                                        ...filterValues.from,
                                        required: true,
                                    }}
                                    openTo="month"
                                    format="MM/yyyy"
                                    placeholder="MM/AAAA"
                                    views={['year', 'month']}
                                    onChange={handleChangeInput}
                                />
                                <DatepickerMui
                                    field={{
                                        ...filterValues.at,
                                        required: true,
                                    }}
                                    openTo="month"
                                    format="MM/yyyy"
                                    placeholder="MM/AAAA"
                                    views={['year', 'month']}
                                    onChange={handleChangeInput}
                                />
                            </S.Row>
                        </S.FirstColumn>
                    </S.container>

                    <S.SecondColumn showFilters={!matchMediaQuery}>
                        <Button type="primary" disabled={loading} onClick={handleSubmit}>
                            Pesquisar
                        </Button>
                    </S.SecondColumn>
                </S.SectionContainer>

                <ContainerDataTable>
                    <DataTableMui
                        clickableRow
                        data={data}
                        emptyMessage={emptyMessage}
                        loading={loading}
                        columns={columnsHead}
                        alreadySearched={alreadySearched}
                        firstOrderBy="nomeBeneficiario"
                    />
                </ContainerDataTable>
            </PageContainer>

            <PageLoader loading={pageLoading} />
        </>
    );
};

export default ConsultarGuias;
